import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  public urlChanged = new BehaviorSubject<string>(null);
  public titleChanged = new BehaviorSubject<string>(null);
  public warningMsg = new BehaviorSubject<string>(null);
}
